// extracted by mini-css-extract-plugin
module.exports = {"board__img":"Present_board__img__33Ikf"};